/* eslint-disable react/no-array-index-key */

/* eslint-disable arrow-body-style */

import { Checkbox } from '@material-ui/core'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
/**
 *
 * ListFilters
 *
 */
import React from 'react'

// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

const styles = theme => ({
  redColor: {
    color: theme.status.requiredColor,
  },
  TableCell: {
    borderRight: '2px solid #eeeef1',
    padding: '10px 6px !important',
  },
})

/* eslint-disable react/prefer-stateless-function */
class STGTableHead extends React.Component {
  render() {
    const { data, classes, onSelectAllClick, tData, selected } = this.props
    return (
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell padding="checkbox" style={{ width: '2%' }}>
            <Checkbox
              indeterminate={selected.length > 0 && tData.length > selected.length}
              checked={tData.length === selected.length && tData.length > 0}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {data.map((column, key) => {
            return column.isVisible ? (
              <TableCell
                key={`cell${
                  // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                  key
                }`}
                numeric={column.numeric}
                padding="none"
                className={classes.tableCell}
                style={{ width: `${column.width}` }}
              >
                {column.label} {column.isMandatory ? <span className={classes.redColor}>*</span> : ''}
              </TableCell>
            ) : (
              ''
            )
          }, this)}
        </TableRow>
      </TableHead>
    )
  }
}

STGTableHead.defaultProps = {}
export default withStyles(styles)(STGTableHead)
